import { Progress } from '@/components/ui/progress';
import React, { Fragment } from 'react';
import Header from './Header';

interface LayoutOutsideProps {
  isLoading?: boolean;
  route?: string;
  text?: string;
  classNameMainContainer?: string;
  children: React.ReactNode;
  isError?: boolean;
  isSuccess?: boolean;
  logout?: () => void;
  hideButton?: boolean;
}

export default function LayoutOutside({
  logout,
  route,
  isLoading,
  text,
  classNameMainContainer,
  children,
  isError,
  isSuccess,
  hideButton,
}: LayoutOutsideProps) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setProgress((prev) => (prev > 100 ? 0 : prev + 1));
      }, 300);
      if (!isLoading) {
        setProgress(100);
      }
      return () => clearInterval(interval);
    }
  }, [isLoading]);

  return (
    <div>
      <Header
        isLoading={isLoading}
        route={route}
        text={text}
        onLogout={logout}
        hideButton={hideButton}
      />
      {isLoading && <Progress className='w-[92%] mx-auto' value={progress} />}
      <main
        className={`${classNameMainContainer} flex p-4 m-auto justify-center w-full items-center`}
      >
        {children}
      </main>
    </div>
  );
}
